import React from 'react';
import {useIsAuthenticated, useMsal} from "@azure/msal-react";

const Logout = () => {

    const { instance, inProgress } = useMsal();
    const isAuthenticated = useIsAuthenticated();

    localStorage.removeItem('selfServiceIdToken');

    instance.logoutRedirect({
        postLogoutRedirectUri: "/",
    });

    return (
        <>
        </>
    );
}

export default Logout;
